module.exports = __webpack_public_path__ + "img/pro-page-onePic.df8399a5.png";